'use client';

import { AppMode } from "@habity/types";
import { useUser } from "~/hooks/useUser";
import { useUsers } from "~/hooks/useUsers";
import { ROUTES } from "@habity/constants";
import { useRouter } from "next/navigation";
import { useCallback } from "react";

export function useModeChange() {
  const { user } = useUser();
  const { updateUser } = useUsers();
  const { push, refresh } = useRouter();

  const changeMode = useCallback(async (mode: AppMode) => {
    if (!user) return;

    try {
      // Update the user's app mode in the database
      const { error } = await updateUser({ app_mode: mode });
      if (error) {
        console.error('Failed to update app mode:', error);
        return;
      }

      // Get the target route for the new mode
      const routes = {
        'buyer': ROUTES.DASHBOARD.BUYER.INDEX,
        'seller': ROUTES.DASHBOARD.SELLER.INDEX,
        'broker': ROUTES.DASHBOARD.BROKER.INDEX
      };

      // Navigate to the new route after the state is updated
      push(routes[mode], { scroll: false });
      // Fetch the user from the server again to refresh the mode
      refresh();
    } catch (err) {
      console.error('Error changing app mode:', err);
    }
  }, [user, updateUser, push, refresh]);

  return { changeMode };
}
